<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>

export default {
    name: 'App',
    created () {
        // window.addEventListener('message', this.listenMessageEvent);
    }
    // methods: {
    //     listenMessageEvent (e) {
    //         console.log('11---------- workflow_params_change666 ---->', e);
    //     }
    // },

    // beforeDestroy () {
    //     window.removeEventListener('message', this.listenMessageEvent);
    // }
};
</script>

<style lang="less">
@import './styles/common.less';

#app {
    text-align: left;
    height: 100%;
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
}
.robot-avatar {
  width: 32px;
  height: 32px;
  border-radius: 32px;
  vertical-align: middle;
  margin-right: var(--spacing-base-loose);
}
html,
body {
    margin: 0;
    height: 100%;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, Arial,"PingFang SC","Microsoft YaHei","Noto Sans",sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
a {
    color: var(--color-primary-normal);
}
</style>



// WEBPACK FOOTER //
// src/App.vue